module.exports = "/React/dist/3d1bd4c590e1b4f8381a1e574f51a240.png";